export default "/images/call-for-purchase.svg?024fce88c34a63e6e06a592e1fb96f64";